import axios from "axios";

export async function removePupilFromCategory(pupilId, categoryId) {
    try {
        const response = await axios.delete(`/pupil/${pupilId}/category/${categoryId}`);
        return response.data;
    } catch (e) {
        const text = e.response?.data?.message || "Ошибка удаления ученика из целевой группы";
        throw new Error(text);
    }
}
